var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSensitiveData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#DEB000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0011 25.3498C19.1009 25.3498 18.3711 24.6201 18.3711 23.7198C18.3711 22.8196 19.1009 22.0898 20.0011 22.0898C20.9013 22.0898 21.6311 22.8196 21.6311 23.7198C21.6311 24.6201 20.9013 25.3498 20.0011 25.3498Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.28 16.28C26.28 13.58 25.63 10 20 10C14.37 10 13.72 13.58 13.72 16.28V17.53C10.92 17.88 10 19.3 10 22.79V24.65C10 28.75 11.25 30 15.35 30H24.65C28.75 30 30 28.75 30 24.65V22.79C30 19.3 29.08 17.88 26.28 17.53V16.28ZM16.98 23.72C16.98 22.05 18.34 20.7 20 20.7C21.66 20.7 23.02 22.06 23.02 23.72C23.02 25.39 21.67 26.74 20 26.74C18.33 26.74 16.98 25.38 16.98 23.72ZM15.12 17.44V16.28C15.12 13.35 15.95 11.4 20 11.4C24.05 11.4 24.88 13.35 24.88 16.28V17.45C24.8 17.45 24.73 17.45 24.65 17.45H15.35V17.44C15.27 17.44 15.2 17.44 15.12 17.44Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensitiveData);
export default __webpack_public_path__ + "static/media/sensitive-data.ea39a413.svg";
export { ForwardRef as ReactComponent };